import React from "react";
import styles from "./InlineLoader.module.scss";

interface Props {
  color?: string;
}

const InlineLoader: React.FC<Props> = ({ color = "var(--first-color)" }) => {
  return (
    <div className={styles.mainContainer}>
      <div className={styles.loadingContainer}>
        <span
          className={styles.circle}
          style={{ backgroundColor: color }}
        ></span>
        <span
          className={styles.circle}
          style={{ backgroundColor: color }}
        ></span>
        <span
          className={styles.circle}
          style={{ backgroundColor: color }}
        ></span>
        <span
          className={styles.circle}
          style={{ backgroundColor: color }}
        ></span>
      </div>
    </div>
  );
};

export default InlineLoader;
